const OutputPower_Icon = ({ className = "" }) => {
  return (
    <svg
      width="26"
      height="26"
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="13" fill="#F2F8F6" />
      <path
        d="M16.0075 9.25L16 7C16 6.5875 15.6625 6.25 15.25 6.25C14.8375 6.25 14.5 6.5875 14.5 7V9.25H11.5V7C11.5 6.5875 11.1625 6.25 10.75 6.25C10.3375 6.25 10 6.5875 10 7V9.25H9.9925C9.175 9.25 8.5 9.925 8.5 10.7425V14.2375C8.5 14.635 8.6575 15.0175 8.935 15.295L11.125 17.5V19C11.125 19.4125 11.4625 19.75 11.875 19.75H14.125C14.5375 19.75 14.875 19.4125 14.875 19V17.5L17.065 15.31C17.3425 15.025 17.5 14.6425 17.5 14.245V10.7425C17.5 9.9175 16.8325 9.25 16.0075 9.25Z"
        fill="#79C8B0"
      />
      <path
        d="M16.0075 9.25L16 7C16 6.5875 15.6625 6.25 15.25 6.25C14.8375 6.25 14.5 6.5875 14.5 7V9.25H11.5V7C11.5 6.5875 11.1625 6.25 10.75 6.25C10.3375 6.25 10 6.5875 10 7V9.25H9.9925C9.175 9.25 8.5 9.925 8.5 10.7425V14.2375C8.5 14.635 8.6575 15.0175 8.935 15.295L11.125 17.5V19C11.125 19.4125 11.4625 19.75 11.875 19.75H14.125C14.5375 19.75 14.875 19.4125 14.875 19V17.5L17.065 15.31C17.3425 15.025 17.5 14.6425 17.5 14.245V10.7425C17.5 9.9175 16.8325 9.25 16.0075 9.25Z"
        fill="url(#paint0_linear_1_18356)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_18356"
          x1="15.8125"
          y1="17.5"
          x2="8.72235"
          y2="13.0202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OutputPower_Icon;
